/**
 * Friendly number formatting in the user's locale.
 * e.g. 10,000 (with the correct thousands' separator)
 */
export function formatNumberLocal(
  value: number,
  options?: Intl.NumberFormatOptions,
  locale?: string | string[],
): string {
  if (!Number.isFinite(value)) {
    return "";
  }

  return new Intl.NumberFormat(locale, options).format(value);
}
